import React from 'react'
import './services.css';
function Services() {
  return (
    <div className='services-container' id="services">COMING SOON...</div>
  )
}

export default Services